<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')" v-show="show">
        <div class="modal-container" @click="$emit('close')">
          <div class="modal-content">
            <img :src="src" class="img-responsive" @click.stop>
          </div>
        </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Lightbox',
  props: ['show', 'src'],
  mounted () {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode === 27) {
        this.$emit('close')
      }
    })
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .85);
  transition: opacity .3s ease;
  cursor: zoom-out;
}
.modal-container {
  height: 100%;
  max-width: 100%;
  margin: auto;
  transition: all .3s ease;
}
@media screen and (min-width: 768px) {
  .modal-container:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
}
.modal-content {
  display: inline-block;
  vertical-align: middle;
  box-shadow: none;
  border: none;
  width: 100%;
  background: transparent;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
img {
  cursor: default;
  margin: auto;
  max-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Lightbox.vue